<template>
    <div class="demand2">
        <div class="searchPart">
            <el-input v-model="orderNo" placeholder="订单编号"></el-input>
            <!--      <el-input v-model="orderName" placeholder="订单名称"></el-input>
                  <el-select v-model="orderCome" placeholder="订单来源">
                    <el-option label="草稿" value="DRAFT"> </el-option>
                    <el-option label="待审核" value="AUDIT"> </el-option>
                    <el-option label="审核通过" value="PASS"> </el-option>
                    <el-option label="审核拒绝" value="REJECT"> </el-option>
                  </el-select>-->
            <el-select v-model="status" placeholder="状态">
                <el-option label="待确认" value="AUDIT"></el-option>
                <el-option label="待发货" value="WAIT_DELIVER"></el-option>
                <el-option label="待收货" value="WAIT_RECEIVE"></el-option>
                <el-option label="已完成" value="DONE"></el-option>
            </el-select>
            <el-button class="searchBtn" @click="search">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="tablePart">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
                        <el-table-column
                          prop="orderTypeCn"
                          label="订单类型"
                          header-align="center"
                          align="center"
                          show-overflow-tooltip
                          width="180"
                        >
                        </el-table-column>
                <el-table-column
                    prop="orderNo"
                    label="订单编号"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="typeCn"
                    label="售后类型"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="reason"
                    label="售后原因"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="申请时间"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="statusCn"
                    label="状态"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="afterSalesDetail(scope.row)"
                        >查看详情
                        </el-button
                        >
                       <!-- <el-button
                            type="text"
                            size="small"
                            v-show="scope.row.auditStatus === 'REJECT'"
                            @click="reApply(scope.row)"
                        >重新申请
                        </el-button
                        >-->
                        <el-button
                            type="text"
                            size="small"
                            v-show="scope.row.status == 'WAIT_DELIVER'"
                            @click="(function (){form.uuid = scope.row.uuid;delivery = true})()"
                        >发货
                        </el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>
        <!-- 发货 -->
        <el-dialog title="发货信息" :visible.sync="delivery">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="物流公司：" prop="logisticsCompany">
                    <el-input v-model="form.logisticsCompany" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="物流单号：" prop="logisticsNo">
                    <el-input v-model="form.logisticsNo" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="delivery = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')"
                >确 定
                </el-button
                >
            </div>
        </el-dialog>
        <!-- 售后详情 -->
        <el-dialog title="售后详情" :visible.sync="afterSalesDialog" width="30%">
            <div class="afterSalesDialog">
                <p>订单类型：</p>
                <p>{{ afterDetial.ordertype }}</p>
            </div>
            <div class="afterSalesDialog">
                <p>订单编号：</p>
                <p>{{ afterDetial.orderNo }}</p>
            </div>
            <div class="afterSalesDialog">
                <p>卖家：</p>
                <p>{{ afterDetial.seller }}</p>
                <i class="iconfont icon-weixin" style="color: #0C75D3;margin-left: 4px;cursor: pointer" @click="startChat(afterDetial.sellerUuid)"></i>
            </div>
            <div class="afterSalesDialog">
                <p>售后类型：</p>
                <p>{{ afterDetial.type }}</p>
            </div>
            <div class="afterSalesDialog">
                <p>售后原因：</p>
                <p>{{ afterDetial.reason }}</p>
            </div>
            <div class="afterSalesDialog">
                <p>申请时间：</p>
                <p>{{ afterDetial.createTime }}</p>
            </div>
            <div class="afterSalesDialog" v-if="afterDetial.returnPrice">
                <p>退款金额：</p>
                <p>{{ afterDetial.returnPrice }}</p>
            </div>
            <div class="afterSalesDialog" v-if="afterDetial.logisticsCompany">
                <p>物流公司：</p>
                <p>{{ afterDetial.logisticsCompany }}</p>
            </div>
            <div class="afterSalesDialog" v-if="afterDetial.logisticsNo">
                <p>物流单号：</p>
                <p>{{ afterDetial.logisticsNo }}</p>
            </div>
            <div class="afterSalesDialog">
                <p>状态：</p>
                <p>{{ afterDetial.status }}</p>
            </div>
            <div class="afterSalesDialog" v-if="afterDetial.auditStatus === 'REJECT'">
                <p>拒绝理由：</p>
                <p>{{ afterDetial.auditReason }}</p>
            </div>
        </el-dialog>


        <!-- 申请售后 -->
        <after-sales-dialog
            ref="afterSalesDialog"
        ></after-sales-dialog>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>

    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import {afterSaleSendOut, getAfterSaleList, getRongCloudUser} from "../../utils/interface";
import afterSalesDialog from "../transaction/orderManagement/afterSalesDialog";
import chatDialog from "../../components/chat/chatDialog";

export default {
    components: {
        afterSalesDialog,
        chatDialog
    },
    data() {
        return {
            orderNo: "",
            status: "",

            tableData: [],
            current: 0,
            pageSize: 10,
            total: 0,
            demandSelection: [],
            form: {
                uuid: '',
                logisticsCompany: '',
                logisticsNo: '',
            },
            delivery: false,
            rules: {
                logisticsCompany: [
                    {required: true, message: '请填写物流公司', trigger: 'blur'}
                ],
                logisticsNo: [
                    {required: true, message: '请填写物流单号', trigger: 'blur'}
                ],
            },
            // 售后详情
            afterSalesDialog: false,
            afterDetial: {
                ordertype: '订单类型',
                orderNo: '订单编号',
                type: '售后类型',
                reason: '售后原因',
                createTime: '申请时间',
                seller: '',
                sellerUuid: '',
                returnPrice: '',
                logisticsCompany: '',
                logisticsNo: '',
                status: '状态',
            }
        };
    },
    computed: {
        ...mapState({}),
    },
    created() {
        this.search();
    },
    methods: {
        // 清除检索条件
        reset() {
            this.orderNo = "";
            this.status = "";
            this.current = 1;
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        search() {
            let params = {
                selectType: "1",
                orderNo: this.orderNo,
                status: this.status,
                current: this.current,
                pageSize: this.pageSize
            };
            getAfterSaleList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        publishSubmit() {
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    afterSaleSendOut(this.form).then((response) => {
                        if (response.success) {
                            this.$message({
                                type: "success",
                                message: "发货信息提交成功",
                                duration: 1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                                onClose: () => {
                                    //跳转页面或执行方法
                                    this.$router.go(0);
                                }
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                        this.delivery = false
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        afterSalesDetail(item) {
            this.afterDetial.orderNo = item.orderNo;
            this.afterDetial.ordertype = item.orderTypeCn;
            this.afterDetial.type = item.typeCn;
            this.afterDetial.reason = item.reason;
            this.afterDetial.reason = item.reason;
            this.afterDetial.status = item.statusCn;
            this.afterDetial.auditStatus = item.auditStatus;
            this.afterDetial.auditReason = item.auditReason;
            this.afterDetial.createTime = item.createTime;
            this.afterDetial.seller = item.seller;
            this.afterDetial.sellerUuid = item.sellerUuid;
            this.afterDetial.returnPrice = item.returnPrice;
            this.afterDetial.logisticsCompany = item.logisticsCompany;
            this.afterDetial.logisticsNo = item.logisticsNo;
            this.afterSalesDialog = true
        },
        reApply(item){
            this.$refs.afterSalesDialog.reApply(item.uuid, item.orderType);
        },
        startChat(targetUuid) {
            // alert(targetUuid);
            let user = this.$store.state.userMessages;
            getRongCloudUser(targetUuid).then(res=> {
                console.log(res);
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
            });
        }
    },
};
</script>

<style scoped lang="less">
.demand2 {
    margin-top: 83px;

    .releaseBox {
        background: #fff;
        padding: 35px;
        padding-top: 0;
        box-sizing: border-box;

        .releaseBoxTop {
            margin-bottom: 15px;

            h4 {
                font-size: 18px;
                color: #157efa;
                margin-bottom: 18px;
            }

            .releaseBoxTopInput {
                font-size: 14px;
                color: #262626;
                align-items: center;
                margin-bottom: 20px;

                /deep/ .ql-toolbar.ql-snow {
                    display: none;
                }

                /deep/ .ql-toolbar.ql-snow + .ql-container.ql-snow {
                    border-top: 1px solid #ccc;
                }

                .releaseBoxTopInputBox {
                    flex-wrap: wrap;
                }

                input {
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border: none;
                    padding-left: 8px;
                    box-sizing: border-box;
                }

                .input2 {
                    width: 161px;
                    // margin-left: 90px;
                }

                textarea {
                    width: 614px;
                    height: 206px;
                    background: #f5f5f5;
                    opacity: 1;
                    border-radius: 6px;
                    border: none;
                    padding: 8px;
                    box-sizing: border-box;
                }

                /deep/ .el-input--prefix .el-input__inner {
                    width: 161px;
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border: none;
                    //   padding-left: 8px;
                    box-sizing: border-box;
                    //   margin-left: 25px;
                }

                // /deep/.el-input__prefix {
                //   right: -132px;
                //   left: 0;
                // }
                /deep/ .el-input__icon {
                    line-height: 30px;
                }

                .releaseBoxbotInputP {
                    width: 94px;
                    flex-shrink: 0;
                    white-space: nowrap;
                }

                .releaseBut {
                    background: #157efb;
                    color: #fff;
                }

                button {
                    width: 100px;
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border: none;
                    margin-right: 20px;
                    color: #262626;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
    }

    .searchPart {
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .tablePart {
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);

                .num {
                    color: #356fdf;
                }

                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157efb;
                    line-height: 30px;
                    text-align: center;

                    &:hover {
                        background: #157efb;
                        box-sizing: border-box;
                        border: 1px solid #157efb;
                        color: #fff;
                    }
                }
            }

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }

        .tableContent {
            min-height: 650px;

            /deep/ .el-table__header {
                tr {
                    th {
                        border-right: none;
                    }
                }

                /deep/ .el-table__cell {
                    padding: 5px 0;
                    background: #f2f5fc;
                }
            }

            /deep/ .el-table__body {
                img {
                    vertical-align: middle;
                    width: 52px;
                    height: 50px;
                }

                /deep/ .el-table__row {
                    td:first-child {
                        border-right: none;

                        .cell {
                            padding-left: 15px;
                        }
                    }
                }
            }
        }

        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
}

/deep/ .el-dialog__body {
    padding-top: 0;
}

.itemFlex {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    .name {
        margin-left: 10px;

        /deep/ p {
            margin: 0 !important;
        }
    }
}

.afterSalesDialog {
    display: flex;
    align-items: center;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/service/afterSalesRecord.vue